export enum FeaturesStepInputNames {
  CareCalendar = 'careCalendar',
  Wishlist = 'wishlist',
  Donations = 'donations',
}
